import { useTranslation } from "react-i18next";
import { ActionItem } from "../../../types";
import ActionRow from "./ActionRow";

interface Props {
  items: ActionItem[];
}

/**
 * "My work" band: everything routed directly at the manager. Unlike
 * TeamAttentionList there is no "see all" — this list is never capped.
 */
const NeedsYouList = ({ items }: Props) => {
  const { t } = useTranslation();

  return (
    <section className="manager-dashboard__band">
      <h2 className="manager-dashboard__band-title">
        {t("managerDashboard.needsYou.title")}
      </h2>
      {items.length === 0 ? (
        <p className="manager-dashboard__empty">
          {t("managerDashboard.needsYou.empty")}
        </p>
      ) : (
        <div className="manager-dashboard__list">
          {items.map((item) => (
            <ActionRow key={`${item.type}-${item.entityId}`} item={item} />
          ))}
        </div>
      )}
    </section>
  );
};

export default NeedsYouList;
